// Helpers for guessing next season's roster tag abbreviation during yearly rollovers.

// Zero-pads n to the given width, e.g. pad(6, 2) => "06"
function pad(n, width) {
  return String(n).padStart(width, '0');
}

// Candidate "next season" versions of a digit run, most likely first.
// Paired seasons bump both halves (2526 => 2627, 56 => 67); anything else bumps as one number
// (2025 => 2026, 25 => 26). Both are returned for runs like 2021 that could be either.
function bumpDigitCandidates(digits) {
  const candidates = [];
  const len = digits.length;
  if (len % 2 === 0) {
    const half = len / 2;
    const mod = 10 ** half;
    const first = parseInt(digits.slice(0, half), 10);
    const second = parseInt(digits.slice(half), 10);
    if ((first + 1) % mod === second) {
      candidates.push(pad((first + 1) % mod, half) + pad((second + 1) % mod, half));
    }
  }
  candidates.push(pad((parseInt(digits, 10) + 1) % (10 ** len), len));
  return candidates;
}

// Candidate next-season abbreviations: bump the last run of digits, keep the letters around it.
// S2526 => S2627, EV2526 => EV2627, 2526 => 2627, LCA56 => LCA67
export function nextSeasonCandidates(abbreviation) {
  const match = /(\d+)(\D*)$/.exec(abbreviation || '');
  if (!match) return [];
  const prefix = abbreviation.slice(0, match.index);
  return bumpDigitCandidates(match[1]).map((digits) => `${prefix}${digits}${match[2]}`);
}

// Best existing replacement for an abbreviation among `abbreviations` (case-insensitive),
// or the abbreviation itself when no candidate exists (i.e. no change).
export function guessNextSeasonTag(abbreviation, abbreviations) {
  const candidates = nextSeasonCandidates(abbreviation);
  for (let i = 0; i < candidates.length; i += 1) {
    const found = abbreviations.find((a) => a.toLowerCase() === candidates[i].toLowerCase());
    if (found) return found;
  }
  return abbreviation;
}
